export const getDeliveryVehicleLabel = vehicle => {
  switch (vehicle) {
    case 'M':
      return 'Moto';
    case 'M_PRO':
      return 'Moto Baú';
    case 'C':
      return 'Carro';
    case 'UV_FIORINO':
      return 'Pick-Up';
    default:
      return '-';
  }
};
